<nb-card [nbSpinner]="waiting" nbSpinnerStatus="success" [hidden]="isFromApp()">

  <nb-card-header>
    <div i18n="@@SubscriptionPlan" class="title">Subscription Plan</div>
  </nb-card-header>

  <nb-card-body class="plans-body">

    <nb-card *ngIf="(currentUser)?.selectedPlan != 'free'">
      <nb-card-header>
        <div i18n="@@SubscriptionPlan">Manage Payment Card</div>
      </nb-card-header>

      <nb-card-body>

      <div i18n="@@InvalidSubscription" *ngIf="(currentUser)?.selectedPlan != (currentUser)?.planCode">
        Your subscription is currently pending payment information. Please update payment information as soon as possible to avoid losing any privileges.
        <br>
      </div>
      <div>

        <button i18n="@@UpdatePaymentInformation" nbButton   *ngIf="(currentUser)?.selectedPlan == (currentUser)?.planCode"
          (click)="updatePaymentInformation()" class="btn-circle btn-xl btn-main"
          type="button">Update Payment Information</button>


          <button i18n="@@UpdatePaymentInformation" nbButton  *ngIf="(currentUser)?.selectedPlan != (currentUser)?.planCode"
          (click)="onClickManageInvalid($event, (currentUser)?.selectedPlan)" class="btn-circle btn-xl btn-main"
          type="button">Update Payment Information</button>

      </div>
      </nb-card-body>
    </nb-card >

    <div class="row plans-container justify-content-center">
      <div class="col-lg-6 col-xl-3 individual-plan" *ngFor="let plan of subscriptionPlans">
        <nb-card class="PlanBox {{(currentUser)?.selectedPlan == plan.planCode ? 'selected':'' }}">
          <nb-card-header>
            <div i18n="PlanFreeTitle|Free Plan@@FreePlanID">{{plan.planName}}</div>
          </nb-card-header>

          <nb-card-body>

            <div class="html-description-container">
              <div>
                <nb-icon class="check-point" icon="checkmark"></nb-icon>
                <span i18n="@@PlanPatients" *ngIf="plan.patientsCount < 1000">Up to <b>{{plan.patientsCount}}</b>
                  clients</span>
                <span i18n="@@UnlimitedPatients" *ngIf="plan.patientsCount == 1000"><b>Unlimited</b> clients</span>
              </div>

              <div [hidden]="plan.planCode == 'free'">
                <nb-icon class="check-point" icon="checkmark"></nb-icon>Archive/Unarchive Clients
              </div>


              <div i18n="@@MobileClientZone">
                <nb-icon class="check-point" icon="checkmark"></nb-icon>Coach and Client Apps
              </div>

              <div>
                <nb-icon class="check-point" icon="checkmark"></nb-icon>Automated Client CheckIn
              </div>

              <div i18n="@@CuratedMealPlansTemplates">
                <nb-icon class="check-point" icon="checkmark"></nb-icon>Curated Meal Plans Templates
              </div>

              <div [hidden]="plan.planCode == 'free'">
                <nb-icon class="check-point" icon="checkmark"></nb-icon>Customize Branding and upload your Logo
              </div>

            </div>

            <div class="monthly-price-tag" i18n="@@MonthlyPriceTag"><b>$ {{plan.price}} USD</b>/month</div>

          </nb-card-body>

          <nb-card-footer>
            <div class="actions-vertical">
              <div *ngIf="(currentUser)?.selectedPlan == plan.planCode" class="current-plan">
                <span i18n="@@CurrentPlan" *ngIf="(currentUser)?.planCode == (currentUser)?.selectedPlan">Current
                  Plan</span>
                <span i18n="@@SelectedPlan" *ngIf="(currentUser)?.planCode != (currentUser)?.selectedPlan">Selected
                  Plan</span>
                <span i18n="@@Pending" *ngIf="(currentUser)?.planCode != (currentUser)?.selectedPlan"> (Pending)</span>
              </div>
              <button *ngIf="(currentUser)?.selectedPlan != plan.planCode" i18n="@@Select" nbButton type="button" class="btn-circle btn-xl btn-main"
                 (click)="onSelect($event, plan)">Select</button>
            </div>
          </nb-card-footer>

        </nb-card>

      </div>
    </div>

  </nb-card-body>

</nb-card>

<nb-card [hidden]="!isFromApp()">

  <nb-card-header>
    <div i18n="@@SubscriptionPlan" class="title">Subscription Plan</div>
  </nb-card-header>

  <nb-card-body>

    Sorry, you cannot perform this action on the mobile app. Please contact us for more details.

  </nb-card-body>
</nb-card>
